import { IconButton, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useGlobalSearchStore } from "../stores/GlobalSearchStore";
import { KEYBOARD_SHORTCUTS } from "../constants/globalSearch.constants";
import { requestLibrarySearchFocus } from "src/features/library/search/librarySearchFocus";

const isMac =
  typeof navigator !== "undefined" &&
  navigator.platform.toUpperCase().indexOf("MAC") >= 0;

interface GlobalSearchButtonProps {
  color?: "inherit" | "default" | "primary" | "secondary";
}

export default function GlobalSearchButton({
  color = "inherit",
}: GlobalSearchButtonProps) {
  const isOpen = useGlobalSearchStore((state) => state.isOpen);
  const openSearch = useGlobalSearchStore((state) => state.openSearch);

  return (
    <Tooltip
      title={`Search (${
        isMac
          ? KEYBOARD_SHORTCUTS.toggle.mac
          : KEYBOARD_SHORTCUTS.toggle.windows
      })`}
    >
      <IconButton
        data-testid="hdr-btn-global-search"
        data-attr="global-search:btn:open-search"
        // On the workspace the pane's search box takes the click (#2377);
        // elsewhere the modal keeps working. Same `!isOpen` guard
        // useGlobalSearchKeyboard applies: a modal already open (e.g. left
        // open from a non-workspace page, then navigated here) must not be
        // bypassed by a pane-focus redirect that leaves both surfaces
        // active with nothing left to close the modal.
        onClick={() => {
          if (!isOpen && requestLibrarySearchFocus()) {
            return;
          }
          openSearch();
        }}
        color={color}
        size="small"
        aria-label="Open search"
      >
        <SearchIcon />
      </IconButton>
    </Tooltip>
  );
}
